<template>
    <v-sheet>
        <v-row>
            <v-col cols="11">
                <v-autocomplete 
                    v-model="selectedItems"
                    :items="innerAllItems"
                    chips
                    multiple           
                    height="25"  
                    outlined
                    :label="label"
                />
            </v-col>
            <v-col cols="1">
                <v-btn 
                    color="blue"
                    fab
                    small
                    class="white--text mt-2"
                    @click="add"
                >
                    <v-icon>
                        mdi-plus
                    </v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col
                v-for="item in innerItems" 
                :key="item"
                cols="3"
            >
                <v-card 
                    shaped
                    hover
                    class="pa-2"
                >
                    <v-card-title>
                        <h2 v-html="item" />
                        <v-btn
                            fab
                            small
                            text
                            color="error"         
                            style="position: absolute; right: 20px;"      
                            @click="deleteItem(item)"             
                        >
                            <v-icon>
                                mdi-delete
                            </v-icon>
                        </v-btn>
                    </v-card-title>
                </v-card>
            </v-col>
        </v-row>
    </v-sheet>           
</template>
<script>
export default {
    name: 'ListEditor',
    props: {
        label: String,        
        value: {
            type: Object,
            default: () => ({
                items: [],
            }),
        },
        allItems: {
            type: Object,
            default: () => ({
                items: [],
            }),
        },
    },
    data: () => {
        return {
            selectedItems: [],
            innerAllItems: [],
            innerItems: [],
        }
    },
    watch: {
        value (v) {
            this.innerItems = v.items.map(user => user.id)
        },
        allItems (v) {
            const allItems = v.items.map(user => user.id)
                .filter(n => !this.innerItems.includes(n))
            this.innerAllItems = allItems
        },
    }, 
    methods: {
        add () {    
            this.innerItems.push(...this.selectedItems)
            const allItems = this.innerAllItems
                .filter(n => !this.innerItems.includes(n))
            this.innerAllItems = allItems
            this.selectedItems = []         
            this.$emit('input', {
                items: this.innerItems.map(i => ({
                    id: i,
                })),
            })
        },
        deleteItem (item) {    
            this.innerItems.push(...this.selectedItems)
            const allInnerItems = this.innerItems
                .filter(n => n !== item)
            this.innerItems = allInnerItems
            this.innerAllItems.push(item)
            this.selectedItems = []
            this.$emit('input', {
                items: this.innerItems.map(i => ({
                    id: i,
                })),
            })
        },
    },
}
</script>
